module.exports = __webpack_public_path__ + "static/media/Santa Rosa Avenue, Santa Barbara, CA5.fd35fa29.jpg";